// components/LanguageSelector.js - Language selector component
import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { FaGlobe, FaCheck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Listbox, Transition } from '@headlessui/react';

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const { t } = useTranslation();
  
  const languages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' }
  ];

  const selectedLanguage = languages.find(lang => lang.code === language) || languages[0];

  return (
    <div className="relative w-10 h-10">
      <Listbox value={selectedLanguage} onChange={(newLanguage) => changeLanguage(newLanguage.code)}>
        <Listbox.Button as={motion.button}
          className="w-10 h-10 rounded-full flex items-center justify-center glass text-white"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          aria-label={t('common.changeLanguage')}
          title={t('common.changeLanguage')}
        >
          <div className="flex items-center">
            <FaGlobe />
            <span className="ml-1 text-xs font-bold">{language.toUpperCase()}</span>
          </div>
        </Listbox.Button>
        
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Listbox.Options className="absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-50 focus:outline-none">
            {languages.map((lang) => (
              <Listbox.Option
                key={lang.code}
                value={lang}
                className={({ active }) => `
                  ${active ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white' : 'text-gray-700 dark:text-gray-200'}
                  cursor-pointer select-none relative py-2 px-4
                `}
              >
                {({ selected, active }) => (
                  <div className="flex items-center justify-between">
                    <span className={`${selected ? 'font-medium' : 'font-normal'}`}>
                      {lang.name}
                    </span>
                    {selected && (
                      <FaCheck className="text-primary-500 dark:text-primary text-sm" />
                    )}
                  </div>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </Listbox>
    </div>
  );
}

export default LanguageSelector;
